import { CSSProperties, ReactNode } from "react"
import {
  CARD_RANK_SURFACE,
  getRankGradientColors,
  usesRankGradient,
} from "@/constants/guardians"
import { ColorRank } from "@/types/battle"

interface CardRankSurfaceProps {
  colorRank: ColorRank
  style?: CSSProperties
  children?: ReactNode
}

export default function CardRankSurface({
  colorRank,
  style,
  children,
}: CardRankSurfaceProps) {
  const gradient = usesRankGradient(colorRank)
  const background = gradient
    ? `linear-gradient(135deg, ${getRankGradientColors(colorRank).join(", ")})`
    : CARD_RANK_SURFACE[colorRank]

  return (
    <div style={{ ...style, background }}>
      {children}
    </div>
  )
}
